// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductBox{background-color:#fff;border-radius:.3125px;height:100%;transition:box-shadow .2s cubic-bezier(.09,.92,.31,.98)}.ProductBox:hover{box-shadow:0 1rem 1rem rgba(0,0,0,.15)}.ProductBox__link{height:100%}.ProductBox__link>div:last-child{margin-top:auto}@media(min-width:1600px){.ProductBox__link>div:last-child{justify-content:flex-end!important}}.ProductBox__name{margin-left:.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
